export default "\n## Send version 2 strings\n\n"